import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { CatalogService } from '@catalog/catalog.service';
import { MatSelectChange } from '@angular/material/select';
import { MAX_PDF_FILE_SIZE,
         Unsupported_PDF_format,
         Max_file_size_10MB ,
         Unsupported_file_format} from '@root/app.constant';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { FileInputComponent } from '@common/file-input/file-input';
import { ErrorHandler } from '@root/utils/error-handler.service';

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss'],
  providers: [CatalogService],
})
export class FormsComponent implements OnInit {
  @ViewChild('f', { static: false }) form: NgForm;

  @ViewChild(FileInputComponent, { static: false })
  fileInputComponent: FileInputComponent;

  @Input() pdfTypes = [];

  @Input() selectedMainTab:string = '';

  @Input() selectedTab : string;

  pdfSectionList = [];

  pdfSubSectionList = [];

  yearList = [];

  monthList = []; 

  selectedType: number;

  selectedSection: string;

  selectedProcessSection: string;

  selectedYear: string;

  selectedMonth: string;

  selectedSubSection: string;

  selecteScheme: string;

  pdfName: string;

  fileName: string;

  file: File;

  mfpdfDataList = [];

  patnerData = [];

  schemeList = [];

  processSection = [];

  constructor(
    private catalogService: CatalogService,
    private toastr: ToastrService,
    private errorHandler: ErrorHandler
  ) {}

  ngOnInit() {
    this.readAllSchems();
    this.readYear();
    this.readMonth();
    this.readProcessSection();
  }

 
  private readAllSchems() {
    this.catalogService.readAllSchemes().subscribe(
      (response) => {
        this.schemeList = response.data.schemes;
      },
      (error) => {}
    );
  }

  public readProcessSection(){
    const obj = {
      'categorySection' : 'process' 
    }
    this.catalogService.getExcelCategories(obj).subscribe(
      response => {
        if (response.status === 0) {
          this.processSection = response.data.categories;
        }
        this.errorHandler.handleError(response);
      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }

  public onTypeChange(change: MatSelectChange) {
    this.pdfSectionList = [];
    this.pdfSubSectionList = [];
    if (change.value && this.selectedMainTab !== 'Expense Ratio') {
      switch (change.value) {
        case 1:
          break;
        case 2:
        case 3:
        case 4:
        case 6:
        case 7:
        case 8:
        case 9:
          this.readPDFSections(this.selectedType);
          break;
        case 5:
          break;
      }
      this.refreshdata(change.value);
    }
    else if(this.selectedMainTab == 'Expense Ratio'){
      this.pdfSectionList = [ {id: 118, type: "Disclosure", typeId: 4, sections: "Total Expense Ratio"}];
      this.refreshdata(change.value);
    }
  }

  public readPDFSections(type) {
    const data = {
      typeId: type,
    };
    this.catalogService.readPDFSections(data).subscribe(
      (response) => {
        this.pdfSectionList = response.data.subTypes;
      },
      (error) => {}
    );
  }

  public onSectionChange(change: MatSelectChange) {
    this.pdfSubSectionList = [];
    if (change.value && this.selectedMainTab !== 'Expense Ratio') {
      this.readSubSection();
    } else {
      this.pdfSubSectionList = [];
    }
  }

  public onYearChange(change: MatSelectChange) {
    this.monthList = [];
      if (change.value) {
        this.readMonth();
      } else {
        this.monthList = [];
      }
  }

  public readYear(){
    const obj = {
      flag : 'all'
    }
    this.catalogService.getYear(obj).subscribe(
      response => {
        if (response.status === 0) {
          this.yearList = response.data.yearList;
        }
        this.errorHandler.handleError(response);
      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }
  public readSubSection() {
    const data = {
      sectionId: this.selectedSection,
    };
    this.catalogService.readPDFSubSections(data).subscribe(
      (response) => {
        this.pdfSubSectionList = response.data.list;
      },
      (error) => {}
    );
  }

  public onSubSelectionChange(change: MatSelectChange) {
    //selection change logic
  }

  public onMonthChange(change: MatSelectChange) {}

  public readMonth(){
    this.catalogService.getMonth().subscribe(
      response => {
        if (response.status === 0) {
          this.monthList = response.data.monthList;
        }
        this.errorHandler.handleError(response);
      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }

  public onFileChange(file: File) {
    if(this.selectedTab === 'PDF'){
      if (file) {
        let isValid =  true;
        this.file = file;
        const fileType = file.name.split('.').pop();
        if (file.type !== 'application/pdf') {
          this.toastr.error(Unsupported_PDF_format);
          isValid =  false;
          this.clearFileComponent();
        }else if (file.size > MAX_PDF_FILE_SIZE) {
          this.toastr.error(Max_file_size_10MB);
          isValid =  false;
          this.clearFileComponent();
        }
      } else {
        this.fileName = null;
      }
    }
    else{
        if (file) {
          let isValid =  true;
          this.file = file;
          const fileType = file.name.split('.').pop();
          if (file.type === 'image/jpeg' || file.type === 'image/png') {
            this.toastr.error(Unsupported_file_format);
            isValid =  false;
            this.clearFileComponent();
          }
          if (file.size > MAX_PDF_FILE_SIZE) {
            this.toastr.error(Max_file_size_10MB );
            isValid =  false;
            this.clearFileComponent();
          }
        } else {
          this.fileName = null;
        }
      }
  }

  private clearFileComponent(){
    if( this.fileInputComponent){
      this.fileInputComponent.clear();
      this.file = null;
      setTimeout(() => {
        this.fileName = null;
      });
    }
  }


  public processData() {
    const formData: any = new FormData();
    formData.append('file', this.file);
    formData.append('type', this.getPdfType());
    formData.append('subType', (this.selectedType === 6 || this.selectedType === 8 )  ? this.selecteScheme : this.getPdfTopic());
    formData.append('month', this.selectedMonth);
    formData.append('year', this.selectedYear);
    formData.append('topic', this.getPdfSubType());
    formData.append('title', this.pdfName);
    this.catalogService.uplaodPDFData(this.selectedType, formData).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.refreshdata(this.selectedType);
          this.resetForm(this.selectedType);
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  public readMFData() {
    this.catalogService.readPDFData(this.selectedType).subscribe(
      (respnose) => {
        this.mfpdfDataList = [...respnose.data.list];
      },
      (error) => {}
    );
  }

  public readPatnerData() {
    this.catalogService.readPDFData(this.selectedType).subscribe(
      (respnose) => {
        this.patnerData = [...respnose.data.list];
      },
      (error) => {}
    );
  }

  private resetForm(type: number) {
    this.fileName = null;
    this.selectedType = null;
    this.selectedSubSection = null;
    this.pdfName = null;
    setTimeout(() => {
      this.selectedType = type ? type : this.pdfTypes[0].type;
    });
    this.form.resetForm();
  }

  public getPdfType(): string {
    const typeObj = this.pdfTypes.find((i) => i.id === this.selectedType);
    return typeObj ? typeObj.type : null;
  }

  public getPdfSubType(): string {
    if (this.selectedSubSection) {
      const subTypeObj = this.pdfSubSectionList.find(
        (i) => i.id === this.selectedSubSection
      );
      return subTypeObj ? subTypeObj.subSections : null;
    }
  }

  public getPdfTopic(): string {
    const topicObj = this.pdfSectionList.find(
      (i) => i.id === this.selectedSection
    );
    return topicObj ? topicObj.sections : null;
  }

  public onSchemeChange(scheme: any) {}

  public refreshdata(type) {
    switch (type) {
      case 1:
      case 2:
      case 5:
      case 7:
      case 8:
      case 9:
        this.readMFData();
        break;
      case 3:
      case 4:
      case 6:
        this.readPatnerData();
        break;
    }
  }
}
